"use strict";

var defaultDelimiter = ', ';

module.exports = function (value) {
  var settings = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var delimiter = settings.delimiter || defaultDelimiter;
  return value.join(delimiter);
};